export class PushSubscription {
    id!: number;
    userId!: number;
    token!: string;
    createdAt?: Date;
    updatedAt?: Date;
  
    constructor(data?: any) {
      if (!data) {
        return;
      }
  
      this.id = data.id;
      this.userId = data.userId;
      this.token = data.token;
      
      if (data.createdAt) {
        this.createdAt = new Date(data.createdAt);
      }
      
      if (data.updatedAt) {
        this.updatedAt = new Date(data.updatedAt);
      }
    }
  }
  
  /**
   * Payload for creating a push subscription
   */
  export class CreatePushSubscriptionPayload {
    token: string;
  
    constructor(token: string) {
      this.token = token;
    }
  }